import { render, staticRenderFns } from "./NotifyDetails.vue?vue&type=template&id=06fca5b3&scoped=true&"
import script from "./NotifyDetails.vue?vue&type=script&lang=ts&"
export * from "./NotifyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./NotifyDetails.vue?vue&type=style&index=0&id=06fca5b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fca5b3",
  null
  
)

export default component.exports